import { Box, ColorOptions, IconButton, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../../components/AdminButton'
import { FC } from 'react'
import { StatusIndicator } from '../../../../../components/StatusIndicator'
import { styles } from './styles'

interface HeaderProps {
  handleOnChange?: (value: string | number[]) => void
  hide?: boolean
  tid: string
  onClose: () => void
  onEditPress?: (isEdit: boolean) => void
  isEditMode?: boolean
  type: string
  status: string
}

const Header: FC<HeaderProps> = ({
  handleOnChange,
  hide = false,
  tid,
  onClose,
  onEditPress,
  isEditMode,
  type,
  status,
}: HeaderProps) => {
  const themes = styles()

  if (hide) {
    return null
  }
  return (
    <Box backgroundColor={'WHITE'}>
      <Box {...themes.headerContainer}>
        <Box {...themes.ernContainer}>
          <ModBox show={type !== 'ENTITY'}>
            <Text fontFamily="jiotype-bold" type={'h3Bold'} color={'PRIMARY_GREY'}>
              {type === 'TID' ? 'TID: ' : tid}
            </Text>
          </ModBox>
          <Text
            fontFamily="jiotype-medium"
            numberOfLines={tid?.length > 20 ? 2 : 1}
            type={'subheading'}
            color={'BLACK'}>
            {tid}
          </Text>
          <Spacer size={16} direction="horizontal" />
          <ModBox show={type !== 'ENTITY'}>
            <StatusIndicator type={status?.toLowerCase()} />
          </ModBox>
        </Box>
        <Box direction="row">
          <ModBox show={type !== 'ENTITY' && type !== 'TID'}>
            <ButtonNew
              type={'secondaryIconSmall'}
              borderWidth={1}
              title={'Edit'}
              borderColor={'#0070B6'}
              borderRadius={4}
              icon="EDIT"
              onPress={onEditPress}
            />
          </ModBox>
          <Spacer size={16} direction="horizontal" />
          <Box {...themes.iconStyle}>
            <IconButton
              testID={'closeDetails'}
              size={20}
              color={'#0070B6' as ColorOptions}
              id={'CLOSE'}
              onPress={onClose}
            />
          </Box>
        </Box>
      </Box>
      <Box h={2} width="100%" backgroundColor={'SEPERATOR'} />
    </Box>
  )
}

export default Header
